
import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {DocSectionExt} from '@/views/doc/DocSectionList.vue';
import {hideCollapse, showCollapse} from '@/utils/bs-collapse';

// expand fold

@Component({
  name: 'doc-section-tree',
})
export default class DocSectionTree extends Vue {

  @Prop({required: true})
  public section!: DocSectionExt;

  @Watch('section.spread')
  public watchSection() {
    if (this.section.spread) {
      showCollapse(this.$refs.collapse as HTMLElement);
    } else {
      hideCollapse(this.$refs.collapse as HTMLElement);
    }
  }

  public mounted() {
    if (this.section.spread) {
      showCollapse(this.$refs.collapse as HTMLElement);
    }
  }

  public toggleSpread() {
    if (this.section.spread) {
      this.$emit('fold', this.section);
    } else {
      this.$emit('expand', this.section);
    }
  }

  public handleFold(section: DocSectionExt) {
    this.$emit('fold', section);
  }

  public handleExpand(section: DocSectionExt) {
    this.$emit('expand', section);
  }

  public select() {
    this.$emit('select', [this.section]);
  }

  public handleSelect(sections: DocSectionExt[]) {
    this.$emit('select', [this.section, ...sections]);
  }
}
